module.exports = __webpack_public_path__ + "static/img/4.c74cc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zsdh/4.png
// module id = CY6K
// module chunks = 0